// Mirrored in applications/platform-app/components/web-analytics — change both.
import React from 'react';
import type { WebRange, RangePreset } from './types';
import { RUBY } from './format';
import { Switch } from './ui';
import { bucketLabel } from './format';

const PRESET_LABEL: Record<RangePreset, string> = { today: 'Today', '7d': '7 days', '30d': '30 days', '90d': '90 days', '12m': '12 months' };

export const customLabel = (r: WebRange) => (r.range === 'custom' && r.from && r.to ? `${bucketLabel(r.from)} – ${bucketLabel(r.to)}` : 'Custom');

/** Range pills + Custom + compare toggle. */
export const RangeBar: React.FC<{
  range: WebRange;
  onPreset: (p: RangePreset) => void;
  onCustom: () => void;
  onCompare: (v: boolean) => void;
  /** Filtered views have no previous period — the toggle is disabled there. */
  compareDisabled?: boolean;
}> = ({ range, onPreset, onCustom, onCompare, compareDisabled }) => {
  const pill = (on: boolean) => `px-3 h-9 min-w-[44px] rounded-[7px] text-xs font-semibold border-0 ${on ? 'text-white' : 'text-stone-500 bg-transparent'}`;
  return (
    <>
      <div className="inline-flex bg-white border border-stone-200 rounded-[10px] p-[3px] flex-wrap" role="group" aria-label="Date range">
        {(Object.keys(PRESET_LABEL) as RangePreset[]).map((p) => {
          const on = range.range === p;
          return (
            <button key={p} type="button" aria-pressed={on} onClick={() => onPreset(p)} className={pill(on)} style={on ? { background: RUBY } : undefined}>
              {PRESET_LABEL[p]}
            </button>
          );
        })}
        <button type="button" aria-pressed={range.range === 'custom'} onClick={onCustom} className={pill(range.range === 'custom')} style={range.range === 'custom' ? { background: RUBY } : undefined} data-testid="wa-range-custom">
          {customLabel(range)}
        </button>
      </div>
      <Switch
        on={range.compare && !compareDisabled} disabled={compareDisabled} onChange={onCompare} testId="wa-compare"
        label={compareDisabled ? 'Compare is off while filters are active' : 'Compare to previous period'}
      />
    </>
  );
};
